export const BASENAME = process.env.REACT_APP_DASHBOARD_BASENAME || '';